import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import { createLoginToken } from 'modules/user/api';
import { intercom } from './intercom';

export const updateIntercomToken = async () => {
  const token = await createLoginToken();
  if (token) {
    intercom.update({
      data: {
        token,
      },
    });
    localStorage.removeItem(LOCAL_STORAGE_KEYS.SHOULD_CREATE_LOGIN_TOKEN);
  }
};
